import React, { Fragment } from "react";
import "./EtheriumLogin.css";
import WhiteEthereumLogo from "../../assets/WhiteEthereumLogo.png";

const EtheriumLogin = () => {
  return (
    <Fragment>
      <section className="container-fluid loginBg">
        <div className="row py-5">
          <div className="col-11 mx-auto etheriumLoginMaxWidth">
            <form className="mt-5">
              <h2 className="EheriumLoginHead">Welcome Back!</h2>
              <p className="EheriumLoginPara">login to your Account</p>

              <fieldset className="etheriumFieldSet mb-5">
                <legend className="float-none w-auto etheriumFieldSetLegend">
                  Email/Username
                </legend>
                <input className="feildsetInput" type="text" />
              </fieldset>
              <input
                className="etheriumpasswordInput mb-5"
                type="text"
                placeholder="Password"
              />
              <div className="d-flex justify-content-between mb-5">
                <button className="btn btnEtheriumSignIn">Sign In</button>
                <button className="btn btnEtheriumSignUp">
                  Create New Account
                </button>
              </div>
              <button className="btn btnEtherium">
                <img
                  className="img-fluid me-3"
                  src={WhiteEthereumLogo}
                  alt=""
                />
                Sign in with Etherium
              </button>
            </form>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default EtheriumLogin;
